import {observer} from 'mobx-react-lite'
import React, {useMemo} from 'react'
import {SearchUtil, Util} from 'yougile-util'
import {Accounts} from '@client/accounts'
import {DepartmentsClient} from '@client/departments-client'
import {EmployeeSettings} from '@client/employee-settings'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {useCompanyInvitePopupStore} from '@components/dashboard/company-invite-popup/company-invite-popup-store'
import {cn} from '@containers/html-utils'
import {ProjectParticipantsRow} from './project-participants-row'
import {useProjectParticipantStore} from './project-participants-store'

export const UsersTab = observer(() => {
  const [state, store] = useProjectParticipantStore()
  const [, inviteStore] = useCompanyInvitePopupStore()
  const bem = Util.bemFrom('project-participants')

  const filteredUsers = useMemo(() => {
    return !state.filter.trim()
      ? state.allUsers
      : state.allUsers.filter(u => {
          const text = [
            EmployeeSettings.getPosition(u.id),
            ...DepartmentsClient.listForUser(store.box, u.id).map(d => d.title),
            Accounts.getName(u.id)
          ].join(' ')
          return SearchUtil.smartSearch(text, state.filter)
        })
  }, [state.filter, state.allUsers])

  const scrollClassName = getScrollClassName(
    store.isCreateProject,
    inviteStore.state.wait
  )

  return (
    <>
      <WithPerfectScrollbar className={cn('min-h-100', scrollClassName)}>
        {filteredUsers.map(u => (
          <ProjectParticipantsRow key={u.id} user={u} />
        ))}
      </WithPerfectScrollbar>

      {inviteStore.state.wait && (
        <div className={bem('mail')}>
          <div className={bem('wait')} />
        </div>
      )}
    </>
  )
})

const getScrollClassName = (isCreateProject: boolean, wait: boolean) => {
  // 109px - блок Приглашение пользователей
  // 76px - блок Новое имя проекта
  // 108px - блок Участники проекта + шапка таблицы
  // 80px - блок wait (спиннер)

  if (isCreateProject) {
    return 'max-h-[calc(100%-76px-108px)]'
  } else {
    if (wait) {
      return 'max-h-[calc(100%-109px-108px-80px)]'
    } else {
      return 'max-h-[calc(100%-109px-108px)]'
    }
  }
}
